import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BaseApiErrorType } from 'src/models/BaseApi';
import { FrontConfigurationFutureFlagsType } from 'src/models/FrontendConfiguration';
import { BaseStoreEntityType, baseStoreEntityValue } from 'src/store/types';

export type FeatureFlagsStateType = BaseStoreEntityType<FrontConfigurationFutureFlagsType>;

const initialState = baseStoreEntityValue<FrontConfigurationFutureFlagsType>({}, true);

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    getFlagsStart: (state) => {
      state = baseStoreEntityValue(null, true);
      return state;
    },
    getFlagsOk: (state, { payload }: PayloadAction<FrontConfigurationFutureFlagsType>) => {
      state = baseStoreEntityValue(payload, false);
      return state;
    },
    getFlagsError: (state, { payload }: PayloadAction<BaseApiErrorType>) => {
      state = baseStoreEntityValue(null, false, payload);
      return state;
    },
  },
});
